import { MouseEventHandler } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  subscriptionAvailable: boolean;
  handleOnClick: MouseEventHandler<HTMLButtonElement>;
  subscriptionSaving?: number;
  isAvailable: boolean;
}

export const ProductSubscriptionButton = (props: Props) => {
  const { t } = useTranslation();
  return (
    <>
      {props.subscriptionAvailable && props.isAvailable && (
        <div className="product-card__subscription-button-wrapper">
          {props.subscriptionSaving !== 0 && (
            <div className="d-flex flex-column align-items-center">
              <p className="subscription-saving-text" aria-hidden="true">
                {t("search.hits.subscription.saving", { saving: Number(props.subscriptionSaving).toFixed(2).replace(".", ",") })}
              </p>
              <span className="sr-only">{t("search.hits.subscription.saving", { saving: Number(props.subscriptionSaving).toFixed(2).replace(".", ",") })}</span>
              <p className="subscription-saving-text text-center" aria-hidden="true">{t("search.hits.subscription.freeShipping")}</p>
              <span className="sr-only">{t("search.hits.subscription.freeShipping")}</span>
            </div>
          )}
          <button
            type="button"
            className="button button--primary button_text_small product-card__cta-button"
            onClick={props.handleOnClick}
            aria-label={t("search.hits.subscription.orderWithSubscription") as string}
          >
            {t("search.hits.subscription.orderWithSubscription")}
          </button>
        </div>
      )}
    </>
  );
};
